import { INITIALIZE_CONFIG } from '../actions/constants/ActionTypes';
const initialState = {};
const Config = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_CONFIG:
      return action.config;
    default:
      return state;
  }
};
export default Config;